export const DYNAMIC_FEEDBACK_SIGNATURE_HEADER = 'x-dynamic-feedback-signature'

/** The env's code for prod refusing a task the PR is no longer linked to: its ticket list is stale. */
export const DYNAMIC_FEEDBACK_UNLINKED_TASK_CODE = 'FORBIDDEN'

/** A task the dynamic env's PR is linked to in prod ACT. */
export interface IDynamicFeedbackTarget {
  id: string
  title: string
  /** Its section on the Atlas Product Board, when it is on the board. */
  sectionName: string | null
  url: string
}

export interface IDynamicFeedbackTargets {
  pullRequestNumber: number
  targets: IDynamicFeedbackTarget[]
  /** Set when the feedback has one obvious home; otherwise the user picks from `targets`. */
  defaultTargetId: string | null
}

export interface IDynamicFeedbackSubmission {
  taskId: string
  title: string
  description?: string
  pageUrl: string
  /** Base64 PNG, without the `data:` prefix. Absent when the capture failed. */
  screenshotBase64?: string
}

export interface IDynamicFeedbackResult {
  subtaskId: string
  subtaskUrl: string
  hasScreenshot: boolean
}
